/**
 * Manage the overlay menu triggered by hamburger nav or 'Where to Buy'
 * header link.
 */

/* global jQuery, TweenMax, Quart */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

const HEADER_HEIGHT = 75;

let $menu = $('.overlay-menu__nav'),                        // Menu block, containing all menu items
    $firstMenuItem = null,                                  // First primary item in menu
    $firstMenuItemLink = null,                              // First primary item link in menu
    $filterMenu = $('.overlay-menu__dish-filter-menu'),     // List of filter items, added as child of first menu item
    $menuContainer = $('.overlay-menu__content'),           // Outer container for the menu block
    filterMenuHeight = null,                                // Store the height of the filter menu, for anim purposes
    flexSwitchHeight = null;                                // Track the height of the filter menu where we switch 
                                                                // flex vertical alignment behavior (used to ensure that
                                                                // the top of the menu is still visible after expansion)


function wireEvents() {
    // Wire the menu (hamburger) icon
    $('.site-header__menu-toggle').click((event) => {
        event.preventDefault();
        openOverlay();
    });

    // Let's also wire the 'where to buy' link that's shown
    // on the desktop header.  Performs a similar function,
    // but ensures that the search form is in view inside
    // of the overlay menu panel.
    $('.site-header__search-link').click((event) => {
        event.preventDefault();
        $('.overlay-menu__content').addClass('js-show-search');
        openOverlay();
    });

    // Listen for clicks on both the close button and the 
    // menu background itself...
    $('.overlay-menu__close-link').click((event) => {
        event.preventDefault();
        closeFilterMenu();
        closeOverlay();
    });
    /*
    // OPTIONAL: If we want to hide menu by clicking on empty
    // part of panel, use this.  Not great UX on search panel...
    $('.overlay-menu').click((event) => {
        event.preventDefault();
        if ($(event.target).is('a, .icon-close, input, label')) {
            // If a link or input was clicked, do nothing
            return;
        } else {
            // Otherwise, close the overlay
            closeFilterMenu();
            closeOverlay();
        }
    });
    */

    // Set up 'Where to Buy' link in the overlay menu
    $('.overlay-menu__search-link').click((event) => {
        $('.overlay-menu__content').addClass('js-show-search');
        // Also, be sure the Our Dishes filter submenu is
        // closed, as this affects our (attached) search
        // form placement
        closeFilterMenu();
    });

}


function openOverlay() {
    // Manage the opening of the menu overlay
    $('.overlay-menu').addClass('is-active is-opaque');
    $('html').addClass('no-scroll');
}
function closeOverlay() {
    // Manage the closing of the menu overlay
    $('.overlay-menu').removeClass('is-active');

    // Remove the 'show search' flag from the menu overlay
    // content (the flag positions the menu such that the 
    // 'search' form is visible - we want the 'nav'
    // panel to be visible the next time the overlay
    // is opened).
    setTimeout(() => {
        $('.overlay-menu').removeClass('is-opaque');
        $('.overlay-menu__content').removeClass('js-show-search');
        $('html').removeClass('no-scroll');
    }, 500);
}

/**
 * Here, we place the filter menu into the WP generated menu list.
 */
function prepFilterMenu() {
    
    if ($filterMenu.length) {
        filterMenuHeight = $filterMenu.show().outerHeight(true);
        $filterMenu.css('height', '0px');
    }

    if ($('#overlay-menu-wp-items li:first-child').length) {
        // Means we're dealing with the theme -- target the first WP-generated
        // overlay menu item
        $firstMenuItem = $('#overlay-menu-wp-items li:first-child');
        $firstMenuItemLink = $('#overlay-menu-wp-items li:first-child > a');
    } else {
        // Means we're dealing with the static template files
        $firstMenuItem = $('.overlay-menu__nav-item:first-child');
        $firstMenuItemLink = $('.overlay-menu__nav-item:first-child > a');
    }
    $filterMenu.appendTo($firstMenuItem);

    $firstMenuItemLink.click((event) => {
        event.preventDefault();
        toggleFilterMenu();
    });
}

/**
 * Provide an explicit method for closing the filter menu
 */
function closeFilterMenu() {
    if ($filterMenu.hasClass('is-open')) {
        toggleFilterMenu();
    }
}

/**
 * Allow for the toggling of the 'Our Dishes' filter sub-menu
 */
function toggleFilterMenu() {
    let winTop = $(window).scrollTop();

    if ($filterMenu.hasClass('is-open')) {
        TweenMax.to($filterMenu, 0.5, {
            height: 0,
            ease: Quart.easeInOut,
            onUpdate: function () {
                // As we collapse the menu, check to see if the height drops
                // below the point where we had applied our flex positioning
                // change.  Once we pass that point, we want to switch back
                // to the original (vertical center) positioning.
                if (flexSwitchHeight && ($filterMenu.height() < flexSwitchHeight)) {
                    if ($menuContainer.hasClass('align-flex-start')) {
                        $menuContainer.removeClass('align-flex-start');
                    }
                }
            }
        });
    } else {
        TweenMax.to($filterMenu, 0.5, {
            height: filterMenuHeight,
            ease: Quart.easeInOut,
            onUpdate: function () {
                // If the expanded filter menu causes the outer menu to be too
                // large to fit, we 'stop' the menu at the top of the container
                // by chaning the flex behavior of the container
                if ($menu.offset().top < (HEADER_HEIGHT + winTop)) {
                    if (!$menuContainer.hasClass('align-flex-start')) {
                        flexSwitchHeight = $filterMenu.height();
                        $menuContainer.addClass('align-flex-start');
                    }
                }
            }
        });
    }
    $filterMenu.toggleClass('is-open');
}


exports.init = function () {
    prepFilterMenu();
    wireEvents();
};

// Allow for external triggering of our search form overlay
exports.showSearchForm = function() {
    $('.overlay-menu__content').addClass('js-show-search');
    openOverlay();
};